import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate, useParams } from 'react-router-dom';
import { resetPasswordCheckCode, resetPasswordCheckUUID } from "../../api/auth.ts";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";

export default function ResetPasswordCodeVerificationPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  const { uuid } = useParams()

  const [formData, setFormData] = useState({
    codigo: "",
  });
  const [displayPage, setDisplayPage] = useState(true);

  useEffect(() => {

    if(!uuid)
    setDisplayPage(false);
    else
    resetPasswordCheckUUID(uuid)
      .then((res) => {
        if (res.error === false) {
          setDisplayPage(true);
        } else {
          setDisplayPage(false);
        }
      })

  }, [uuid]);
 
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 

  const handleSubmit = (e) => {
    
    e.preventDefault();

    console.log(uuid);
    console.log(formData);

    resetPasswordCheckCode(uuid, formData.codigo).then((res) => {
      if (res.error === true) {
        Swal.fire({
          text: res.msg,
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      } else {
        
        Swal.fire({
          text: "Código verificado correctamente.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        navigate('/recuperar-password/modificar/' +uuid);
       
      }
    });
  };

  

  return (
    <div>
     { displayPage ?
        <div className="mc-auth">
           <img src="images/Login.png" alt="pattern" className="mc-auth-pattern mc-auth-pattern-desktop" />
      <img 
        src="images/Loginphone.png" 
        alt="pattern" 
        className="mc-auth-pattern mc-auth-pattern-mobile"
        onError={(e) => {
          // Fallback a la imagen desktop si la móvil no existe
          e.target.src = "images/Login.png";
        }}
      />
          <div className="mc-auth-group">
            <br></br>
         <br></br>
          <br></br>
           <br></br>
            <br></br>
             <br></br>
              <br></br>
               <br></br>
            <h4 className="mc-auth-title">Ingrese el código de 4 dígitos enviado a su correo electrónico:</h4>
            <form className="mc-auth-form" onSubmit={handleSubmit}>
              <IconFieldComponent
                icon="email"
                type="text"
                name="codigo"
                classes="h-sm"
                placeholder="Ingrese su código"
                onChange={handleInputChange}
              />
              <ButtonComponent className="mc-auth-btn h-sm" type="submit">
                Validar Código
              </ButtonComponent>
            </form>
            <div className="mc-auth-navigate">
              <span>¿Recuerdas la contraseña?</span>
              <AnchorComponent to="/login">{t("login")}</AnchorComponent>
            </div>
          </div>
        </div>
       :
       <div className="mc-auth">
          <img
            className="mc-auth-pattern"
            src="images/logo.png"
            alt="pattern"
          />
          <div className="mc-auth-group">
            <LogoComponent
              src="images/logo.png"
              alt="logo"
              href="/ecommerce"
              className="mc-auth-logo"
            />
            <h4 className="mc-auth-title">El código ingresado no es válido o ha expirado.</h4>
           
          </div>
        </div>
     }
    </div>
  );
}